import seoImg from "../images/digital-marketing/feature1-red.png";
import contentMarketingImg from "../images/digital-marketing/feature2-red-e1524249893294.png";
import socialMarketingImg from "../images/digital-marketing/feature3-red-e1524249939863.png";
import designAndDevelopmentImg from "../images/digital-marketing/feature4-red-e1524249975507.png";
import conversionRateImg from "../images/digital-marketing/feature5-red-e1524250079237.png";
import paidMediaImg from "../images/digital-marketing/feature6-red-e1524250013671.png";

export const digitalMarketingServices = [
  {
    title: "Search Engine Optimization",
    img: seoImg,
    description:
      "Today’s search engines are getting smarter and more complex. At MWI, we keep up with the latest search algorithm changes so your rankings keep improving.",
  },
  {
    title: "Content Marketing",
    img: contentMarketingImg,
    description:
      "Videos, ebooks, infographics, podcasts, and more. MWI crafts customized content that converts by educating, entertaining, and engaging your ideal customers.",
  },
  {
    title: "Social Media Marketing",
    img: socialMarketingImg,
    description:
      "At MWI, we’ll help you build a community of loyal customers with a social media strategy focused on creating and curating quality content. ",
  },
  {
    title: "Design & Development",
    img: designAndDevelopmentImg,
    description:
      "We combine user-experience-based design and SEO-friendly development principles to create websites that both search engines and your customers will love.",
  },
  {
    title: "Conversion Rate Optimization",
    img: conversionRateImg,
    description:
      "We use web analytics and real-user testing to discover how your site can reduce bounce rates and increase conversions.",
  },
  {
    title: "Paid Media",
    img: paidMediaImg,
    description:
      "Our paid search and paid social advertising campaigns are based on solid understanding of your ideal customers, so your ads can deliver traffic that converts.",
  },
];
